<template lang="pug">
  .cms-partial(v-if="html")
    component(:is="htmlComponent" v-on="$listeners" v-bind="$props" :client-config="config")
    component(is="style" v-if="css") {{css}}

</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex';

  export default {
    name: "CMSPartial",

    props: {
      mixinKey: {
        type: String,
        default: '',
      },
      initHtml: {
        type: String,
        default: '',
      },
      initCss: {
        type: String,
        default: '',
      },
      config: {
        type: Object,
        default: () => ({})
      }
    },

    computed: {
      ...mapGetters('cms', ['getPartial']),
      ...mapState('global', ['isVueSSRApp']),

      htmlComponent() {
        return {
          template: this.html,
          props: {
            clientConfig: {
              type: Object,
              default: () => ({})
            }
          }
        };
      },

      partial() {
        return this.getPartial(this.mixinKey);
      },

      html() {
        return this.partial ? this.partial.html : null;
      },

      css() {
        return this.partial ? this.partial.css : null;
      }
    },

    watch: {
      mixinKey: {
        handler: 'update',
      }
    },

    async created() {
      if (!this.isVueSSRApp || !this.partial) {
        await this.init();
      }
    },

    async serverPrefetch() {
      if (this.isVueSSRApp && !this.partial) {
        await this.init();
      }
    },

    methods: {
      ...mapActions('cms', [
        'loadPartial',
      ]),

      async init() {
        if (this.initHtml && this.initCss) {
          this.html = this.initHtml;
          this.css = this.initCss;
        }

        await this.update();
      },

      async update() {
        if (this.mixinKey) {
          await this.loadPartial({ mixinKey: this.mixinKey });
        }
      },
    },
  };
</script>

<style scoped lang="stylus">
</style>
